const INIT_STATE = {
    cardFigures : [],
    topInspectors:[],
    worstInspector : [],
    topClient : [],
    worstClient : [],
    textMessage : '',
    revenueOverview : null,
    inspectionOverview : [],
    onGoingInspections :[],
    inspectionStatistics : [],
    recentActivity : []

}
export default  (state = INIT_STATE, action) => {
    switch (action.type) {
        case 'getGeneralAnalytics_SUCCESS':
            return {
                ...state,
                cardFigures : action.payload.Record,
                inspectionStatistics : action.payload.Record[0].inspectionsStatistics
            }
        case 'getTopWorstInspector_SUCCESS':{
            return {
                ...state,
                topInspector : action.payload.Record.topInspector,
                worstInspector : action.payload.Record.worstInspector
            }
        }
        case 'getTopWorstClient_SUCCESS':{
            return {
                ...state,
                topClient : action.payload.Record.topClient,
                worstClient : action.payload.Record.worstClient
            }
        }
        case 'getRevenueOverview_SUCCESS':{
            return {
                ...state,
                revenueOverview : action.payload.Record
                
            }
        }
        case 'getInspectionOverview_SUCCESS': {
            return {
                ...state,
                inspectionOverview : action.payload.Record
                
            }
        }
        case 'getOnGoingInspection_SUCCESS': {
            return {
                ...state,
                    onGoingInspections : action.payload.Record
                
            }
        }
        case 'getInspectionStatistics_SUCCESS':{
            return {
                ...state,
                inspectionStatistics : action.payload.Record
                
            }
        }
        case 'getRecentActivity_SUCCESS':{
            return {
                ...state,
                recentActivity : action.payload.Record
                
            }
        }

        
        default:
            return state
    }
}


 